module.exports = __webpack_public_path__ + "img/soft-grove-bedroom-1.a0a683d6.jpeg";